<template>
  <div style="font-size: 14px;display: flex;">
    <div style="height: 50px;">
      <img src="../../../public/img/logo.png" style="height: 40px;margin: 10px 20px;" @click="homePage">
    </div>
    <div class="my-search" style="flex: 1;text-align: center;">
      <el-input placeholder="" v-model="kw" style="width: 500px;margin-top: 10px;" clearable>
        <el-button slot="append" icon="el-icon-search" @click="toSearch"></el-button>
      </el-input>
    </div>
    <div style="width: 330px;display: flex;margin-top: 5px;">
      <!-- <div style="line-height: 60px;margin-right: 20px;">
        <svg style="margin-top: 12px;" class="pointer svg_quick_icon svg_icon_vip" viewBox="0 0 26 26" width="26" height="26"><filter x="-17.4%" y="-16%" width="134.8%" height="132%" filterUnits="objectBoundingBox" id="__gradient_vip1"><feOffset in="SourceAlpha" result="shadowOffsetOuter1"></feOffset><feGaussianBlur stdDeviation="1" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" in="shadowBlurOuter1" result="shadowMatrixOuter1"></feColorMatrix><feMerge><feMergeNode in="shadowMatrixOuter1"></feMergeNode><feMergeNode in="SourceGraphic"></feMergeNode></feMerge></filter><linearGradient x1="-4.4%" y1="3.5%" x2="58.5%" y2="104.9%" id="__gradient_vip2"><stop stop-color="#FFF1CC" offset="0%"></stop><stop stop-color="#FFCD45" offset="36.9%"></stop><stop stop-color="#FF7000" offset="100%"></stop></linearGradient><linearGradient x1="20.3%" y1="11.1%" x2="86.2%" y2="88.9%" id="__gradient_vip3"><stop stop-color="#FFF8E6" offset="0%"></stop><stop stop-color="#FFCD45" offset="44.5%"></stop><stop stop-color="#FF7000" offset="100%"></stop></linearGradient><linearGradient x1="0%" y1="35.6%" x2="50%" y2="94.2%" id="__gradient_vip4"><stop stop-color="#FFF1CC" offset="0%"></stop><stop stop-color="#FFCD45" offset="40.9%"></stop><stop stop-color="#FF7000" offset="100%"></stop></linearGradient><g filter="url(#__gradient_vip1)" transform="translate(2 1)" fill="none" fill-rule="evenodd"><path d="M18.2.1l-6.8 12h-.1L4.5 0h-4C.3.1 0 .5.3.8l10.7 19c.2.4.7.4.9 0L22.6.8c.1-.3 0-.7-.5-.7h-3.9z" transform="translate(0 3.4)" fill="url(#__gradient_vip2)" stroke="#FFF" stroke-opacity=".8" stroke-width=".2"></path><path d="M0 0l5.9 10.4L11.8 0z" transform="translate(5.5 3.4)" fill="url(#__gradient_vip3)" opacity=".3"></path><path d="M1.7 6.2L6 4.3l4.2 1.9 1.6-2.8v-.6-1.3-1c0-.2-.2-.4-.5-.4H11L6 2.4h-.2L.8.1H.6C.3.1 0 .3 0 .6v2.8l1.6 2.8z" transform="translate(5.5)" fill="url(#__gradient_vip4)" stroke="#FFF" stroke-opacity=".8" stroke-width=".2"></path></g></svg>
      </div> -->
      <!-- <div>
        <i class="el-icon-c-scale-to-original pointer" style="font-size: 30px;color: #c6c6c6;line-height: 50px;margin-right: 20px;"></i>
      </div> -->
      <!-- <div>
        <i class="el-icon-timer pointer" style="font-size: 30px;color: #c6c6c6;line-height: 50px;margin-right: 20px;"></i>
      </div>
      <div>
        <i class="el-icon-video-camera pointer" style="font-size: 30px;color: #c6c6c6;line-height: 50px;margin-right: 20px;"></i>
      </div>
      <div>
        <i class="el-icon-s-platform pointer" style="font-size: 30px;color: #c6c6c6;line-height: 50px;margin-right: 20px;"></i>
      </div> -->
      <div v-if="isLogin" style="color: antiquewhite;padding-top: 10px;">
        {{account}} 
      </div>
      <div v-if="isLogin" style="color: antiquewhite;padding-top: 10px;padding-left: 20px;">
        余额 {{balance}}
      </div>
      <div v-if="isLogin" style="color: antiquewhite;padding-top: 10px;padding-left: 20px;" @click="logout">
       退出
      </div>
      <div v-else>
        <el-avatar icon="el-icon-user-solid pointer" style="margin-top: 5px;" @click.native="login"></el-avatar>
      </div>
      
    </div>
  </div>
</template>

<script>
  export default {
      data() {
        return {
          kw: '',
          account:'',
          balance:0,
          isLogin:false,
        };
      },
      created (){
        this.account = localStorage.getItem('account');
        this.balance = localStorage.getItem('balance');
        console.log(localStorage.getItem('account'));
        if(typeof this.account== "undefined" || this.account== null || this.account== ""){
          this.isLogin=false;
        }else{
          this.isLogin=true;
        }
      },
      mounted() {
      },
      methods: {
         homePage(){
           this.$router.push({path: '/index'});
         },
         login(){
           this.$router.push({path: '/login'});
         },
         logout(){
          this.account='';
          this.isLogin=false;
          localStorage.clear();
         },
         toSearch(){
          console.log('search');
          if(this.kw==''){
            console.log('为空');
          }else{
            this.$router.push({path:'/search?kw='+this.kw})
          }
        }
      }
    };
</script>

<style>
  .menu{
    margin: 0 20px;
    font-size: 16px;
  }
  .menu:hover{
    cursor: pointer;
    color: #ff0e0b !important;
  }
  .but:hover{
    cursor: pointer;
    color: #ff0e0b !important;
  }
  .my-search .el-input__inner{
    background-color: #666666;
    border-color: #666666;
    color: #ffffff;
  }
  .my-search .el-input-group__append, .el-input-group__prepend{
    background-color: #666666!important;
    color: #ffffff!important;
    border: none!important;
  }
  .my-search .el-input-group__append:hover{
    background-color: #878787 !important;
  }
</style>



// WEBPACK FOOTER //
// src/page/top/index.vue